import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CalendarFilter } from 'src/app/models/CalendarFilter';
import { ClassSummary, Student } from 'src/app/models/CalendarModels';
import { ClassScheduleRequest, StudentScheduleRequest } from 'src/app/models/CalendarRequest';
import { Schedule_ep } from 'src/app/models/Schedule_ep';
import { CalendarService } from 'src/app/services/calendar.service';
import { StudentScheduleService } from 'src/app/services/student-schedule.service';
import { OptionSet } from '../../../models/OptionSet';
import { SaveStudentsDialogComponent } from '../save-students-dialog/save-students-dialog.component';
import { ScheduleGridComponent } from '../schedule-grid/schedule-grid.component';
import { SchedulesService } from 'src/app/services/schedules.service';

@Component({
  selector: 'app-student-schedule',
  templateUrl: './student-schedule.component.html',
  styleUrls: ['./student-schedule.component.scss']
})
export class StudentScheduleComponent implements OnInit, AfterViewInit {
  @ViewChild(ScheduleGridComponent) scheduleGrid: ScheduleGridComponent;
  @Input() enableUpdateAll: boolean;
  @Output() callback = new EventEmitter();
  loading: boolean = false;
  studentSearchData: CalendarFilter;
  selectedClassSchedules: any[];
  studentSelected: any[] = [];
  privateStudentsSelected: any[] = [];

  constructor(public calendarSvc: CalendarService, public dialog: MatDialog, private schedulesSvc: SchedulesService) {
    this.calendarSvc.studentSelected.subscribe(res => {
      this.studentSelected = res;
      this.privateStudentsSelected = [];
      this.studentSelected.forEach((x: Student) => {
        if ((this.calendarSvc.isNoonMode && x.noonSchedule?.IsPrivate) || (!this.calendarSvc.isNoonMode && x.MainSchedule?.IsPrivate)) {
          this.privateStudentsSelected.push(x);
        }
      }
      );
    });
    calendarSvc.studentScheduleSelected.subscribe((data: any) => {
      if (data != null && data.IsPrivate == true) {
        this.scheduleGrid.initForm(data, true);
      }
      else {
        if (this.selectedClassSchedules?.length == 1) {
          let s = this.calendarSvc.classSchedulesList.find(x => x.Id_e == this.selectedClassSchedules[0].Id_e && x.Id_p == this.selectedClassSchedules[0].Id_p);
          if (s) {
            //this.scheduleGrid.initForm(s, false);
            return;
          }
        }
        this.scheduleGrid.clearForm();
      }
    });

    this.calendarSvc.filterSubject.subscribe((data: CalendarFilter) => {
      if (data.ClassesValues.length > 0) {
        this.scheduleGrid.initForm(this.calendarSvc.accountSchedule, false);
      }
    });
    this.calendarSvc.wideFilterSubject.subscribe((data: any[]) => {
      this.selectedClassSchedules = data;
      if (data.length > 0) {
        if (data.length == 1) {
          let s = this.calendarSvc.classSchedulesList.find(x => x.Id_e == data[0].Id_e && x.Id_p == data[0].Id_p);
          if (s)
            this.scheduleGrid.initForm(s, true);
          else
            this.scheduleGrid.clearForm();
        }
        else this.scheduleGrid.initForm(this.calendarSvc.accountSchedule, true);

      }
      else {
        this.scheduleGrid.clearForm();
      }
    });
  }
  ngAfterViewInit(): void {
    // debugger
    // this.scheduleGrid.initForm(this.calendarSvc.accountSchedule); 
  }

  ngOnInit(): void {

  }

  updateSelectedStudents() {
    let selectedStudents = this.calendarSvc.studentsListFiltered.filter(x => x._checked);
    if (selectedStudents.length > 0) {
      // this.loading = true;
      this.calendarSvc.spinnerSubjectEmit(true);
      let schedule = this.buildScheduleObj();
      let request: StudentScheduleRequest = {
        Schedule: schedule,
        StudentsList: selectedStudents.map(x => { return x; }),
        UpdateMainSchedule: !this.calendarSvc.isNoonMode
      };
      this.calendarSvc.saveStudentSchedule(request).then((res: any) => {
        if (!this.calendarSvc.dataService.IsError(res)) { }
        this.scheduleGrid.clearForm();
        this.selectedClassSchedules = [];
        this.callback.emit();
        // }
        this.calendarSvc.spinnerSubjectEmit(false);
      }).catch(err => {
        debugger
        this.calendarSvc.spinnerSubjectEmit(false);
        alert("ארעה שגיאה");
      });
    }
    ////רועי - לא רלוונטי
    // else {
    //   //אם אין תלמידים - יעדכן את המערכת של הכיתה שנבחרה
    //   //if (this.selectedClassSchedules?.length > 0) {
    //   this.updateAllStudents();
    //   // }
    //}
  }

  groupBy(array, f) {
    var groups = {};
    array.forEach(function (o) {
      var group = JSON.stringify(f(o));
      groups[group] = groups[group] || [];
      groups[group].push(o);
    });
    return Object.keys(groups).map(function (group): ClassSummary {
      let x = JSON.parse(group)
      return { Class: x[0], ClassCode: x[1], Classification: x[2] };
    })
  }

  openSaveStudentsModal() {
    let privateStudents: Student[];
    if (this.calendarSvc.isNoonMode) {
      privateStudents = this.calendarSvc.studentsListFiltered.filter(x => x.noonSchedule?.IsPrivate);
    }
    else {
      privateStudents = this.calendarSvc.studentsListFiltered.filter(x => x.MainSchedule?.IsPrivate);
    }
    if (privateStudents.length == 0) {
      this.updateAllStudents(true);
    }
    else {
      const dialogRef = this.dialog.open(SaveStudentsDialogComponent);
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        switch (result) {
          case true://create general vacation for all students
          case false: //create private vacation to each student
            this.updateAllStudents(result);
            break;
          default://cancel
            break;
        }
      });
    }
  }

  updateAllStudents(toUpdateAllStudents: boolean = false) {
    this.calendarSvc.spinnerSubjectEmit(true);
    let SchedulesToUpdate: Schedule_ep[] = [];
    let StudentsToUpdate: Student[] = [];
    let schedules: Schedule_ep[] = [];
    var classesSummary = this.groupBy(this.studentSelected, function (item: Student) {
      return [item.Class, item.ClassCode, item.Classification];
    });
    if (this.calendarSvc.isNoonMode) {
      if (this.selectedClassSchedules?.length > 0) {
        classesSummary = [];
        let item = this.selectedClassSchedules[0];//לצהרון קימת רק מערכת אחת
        let item2 = this.calendarSvc.classSchedulesListFiltered.find(x => x.Id_e == item.Id_e && x.Id_p == item.Id_p);
        let s = new Schedule_ep();
        s.Id_e = item2.Id_e;
        s.Id_p = item2.Id_p;
        s.Class = item2.Class;
        s.ClassCode = item2.ClassCode;
        s.Classification = item2.Classification;
        SchedulesToUpdate.push(s);
      }
      else {
        classesSummary = [];
        classesSummary.push({ Class: { value: "400", viewValue: "צהרון" } });
      }
      if (toUpdateAllStudents) {
        StudentsToUpdate = this.calendarSvc.studentsListFiltered;
      }
      else {
        this.studentSelected.forEach(item => {
          if (item.noonSchedule?.IsPrivate == false) {
            StudentsToUpdate.push(item);
          }
        });
      }
    }
    else {
      schedules = this.selectedClassSchedules ? this.selectedClassSchedules : this.calendarSvc.classSchedulesListFiltered;
      schedules.forEach(item => {
        let item2 = this.calendarSvc.classSchedulesListFiltered.find(x => x.Id_e == item.Id_e && x.Id_p == item.Id_p);
        let index = classesSummary.findIndex(x => JSON.stringify(x.Class) == JSON.stringify(item2.Class) && JSON.stringify(x.ClassCode) == JSON.stringify(item2.ClassCode)
          && JSON.stringify(x.Classification) == JSON.stringify(item2.Classification));
        if (index != -1 || classesSummary.length == 0) {
          if (index != -1) {
            classesSummary.splice(index, 1);
          }
          let s = new Schedule_ep();
          s.Id_e = item2.Id_e;
          s.Id_p = item2.Id_p;
          s.Class = item2.Class;
          s.ClassCode = item2.ClassCode;
          s.Classification = item2.Classification;
          SchedulesToUpdate.push(s);
        }
      })
      if (toUpdateAllStudents) {
        if (this.calendarSvc.studentsListFiltered.length == 0) {//יצירת מערכת שעות כיתתית ללא תלמידים בכיתה
          if (this.schedulesSvc.selectedClasses?.length > 0) {
            classesSummary = [];

            this.schedulesSvc.selectedClasses.forEach(selectedClass => {

              let hasClassCodesForThisClass = false;

              if (this.schedulesSvc.selectedClassCodes?.length > 0) {
                this.schedulesSvc.selectedClassCodes.forEach(selectedClassAndCode => {
                  const classValue = selectedClassAndCode.value.substring(0, 3);

                  if (classValue === selectedClass.value) {
                    hasClassCodesForThisClass = true;

                    const classCodeValue = selectedClassAndCode.value.substring(3);

                    const actualClassCode = {
                      value: classCodeValue,
                      viewValue: selectedClassAndCode.viewValue.replace(selectedClass.viewValue, '')
                    };

                    if (this.schedulesSvc.selectedClassification?.length > 0) {
                      classesSummary.push({
                        Class: selectedClass,
                        ClassCode: actualClassCode,
                        Classification: this.schedulesSvc.selectedClassification[0]
                      });
                    } else {
                      classesSummary.push({
                        Class: selectedClass,
                        ClassCode: actualClassCode,
                        Classification: null
                      });
                    }
                  }
                });
              }

              if (!hasClassCodesForThisClass) {
                if (this.schedulesSvc.selectedClassification?.length > 0) {
                  classesSummary.push({
                    Class: selectedClass,
                    ClassCode: null,
                    Classification: this.schedulesSvc.selectedClassification[0]
                  });
                } else {
                  classesSummary.push({
                    Class: selectedClass,
                    ClassCode: null,
                    Classification: null
                  });
                }
              }
            });
          }
        } else {
          this.calendarSvc.studentsListFiltered.forEach(item => {
            if (item.MainSchedule?.IsPrivate) {
              StudentsToUpdate.push(item);
            }
          });
        }
      }
    }

    let request: ClassScheduleRequest = {
      Schedule: this.buildScheduleObj(),
      ClassesToCreate: classesSummary,
      SchedulesToUpdate: SchedulesToUpdate,
      StudentsToUpdate: StudentsToUpdate,
      UpdateMainSchedule: !this.calendarSvc.isNoonMode
    };
    this.calendarSvc.saveClassSchedule(request).then((res: any) => {
      if (!this.calendarSvc.dataService.IsError(res)) { }
      this.scheduleGrid.clearForm();
      this.selectedClassSchedules = [];
      this.callback.emit();
      // }
      // this.calendarSvc.spinnerSubjectEmit(false);
    }).catch(err => {
      debugger
      this.calendarSvc.spinnerSubjectEmit(false);
      alert("ארעה שגיאה");
    });
  }

  updateFromClassSchedule() {
    this.calendarSvc.spinnerSubjectEmit(true);
    let StudentsToUpdate: Student[] = [];
    this.calendarSvc.studentsListFiltered.forEach(item => {
      if (item._checked)
        if ((!this.calendarSvc.isNoonMode && item.MainSchedule) || (this.calendarSvc.isNoonMode && item.noonSchedule)) {
          StudentsToUpdate.push(item);
        }
    });
    let request: ClassScheduleRequest = {
      Schedule: this.buildScheduleObj(),
      ClassesToCreate: [],
      SchedulesToUpdate: [],
      StudentsToUpdate: StudentsToUpdate,
      UpdateMainSchedule: !this.calendarSvc.isNoonMode
    };
    this.calendarSvc.saveClassSchedule(request).then((res: any) => {
      if (!this.calendarSvc.dataService.IsError(res)) { }
      this.scheduleGrid.clearForm();
      this.selectedClassSchedules = [];
      this.callback.emit();
      // }
      // this.calendarSvc.spinnerSubjectEmit(false);
    }).catch(err => {
      debugger
      this.calendarSvc.spinnerSubjectEmit(false);
      alert("ארעה שגיאה");
    });
  }

  getOptionsByViewValue(target: string[], source: OptionSet[]): OptionSet[] {
    let res: OptionSet[] = target.map(x => source.find(y => y.viewValue == x));
    return res;
  }

  buildScheduleObj() {
    let schedule = new Schedule_ep();
    Object.keys(this.scheduleGrid.form.controls).forEach(key => {
      var value = this.scheduleGrid.form.get(key).value;
      if (value != null) {
        var option = this.calendarSvc.ScheduleHoursList.find(x => x.value == value);
        schedule[key] = option
      }
    });
    return schedule;
  }

}
